import axios from "axios";
// variabile che contiene la config con il quale chiamiamo l'api
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  validateStatus: function (status: number): boolean {
    return status >= 200 && status < 400
  }
});

// api.interceptors.request.use((config) => {

//   return config;
// });


// api.interceptors.response.use((config) => {
   
//       return config;
//     });

export const apiWithoutInterceptor = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  validateStatus: function (status: number): boolean {
    return status >= 200 && status < 400
  }
})
export default api;